import {
  SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
  SYS_COLOR_SURFACE_NEUTRAL_100_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_400_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
} from '@oneaudi/unified-web-common';
import {
  SYS_COLOR_CANVAS_200_DARK,
  SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DEFAULT_DARK,
  SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_100_FILL_DARK,
  SYS_BORDER_RADIUS_MAX,
  SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_DARK,
  SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DISABLED_DARK,
  SYS_COLOR_SURFACE_NEUTRAL_100_DARK,
  SYS_GRADIENT_ELEVATION_LEVEL3_FILL_DARK,
  SYS_PAGE_MARGIN,
  SYS_COLOR_FOREGROUND_NEUTRAL_300_DARK,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_350,
  SYS_SPACE_FIXED_300,
} from '@oneaudi/unified-web-alpha-common';
import { colord } from 'colord';
import type { CustomTheme } from '../@types/theme';

/*
  Define  color tokens.
  (preferably use "only" tokens from @oneaudi/unified-web-common)
*/
const colorsLight = {
  colorCanvasDefault: SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
  sysColorSurfaceNeutral100: SYS_COLOR_SURFACE_NEUTRAL_100_LIGHT,
  sysColorSurfaceNeutral400: SYS_COLOR_SURFACE_NEUTRAL_400_LIGHT,
  sysColorSurfaceNeutral600: SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT,
  sysColorSurfaceNeutral800: SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
  sysColorSurfaceNeutral800WithOpacity: colord(SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT)
    .alpha(0.5)
    .toRgbString(),
  globalColorElevationLevel1: SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
};

const colorsDark = {
  colorCanvasDefault: SYS_COLOR_CANVAS_200_DARK,
  sysColorSurfaceNeutral100: SYS_COLOR_SURFACE_NEUTRAL_100_DARK,
  sysColorSurfaceNeutral400: SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DISABLED_DARK,
  sysColorSurfaceNeutral600: SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT,
  sysColorSurfaceNeutral800: SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DEFAULT_DARK,
  sysColorSurfaceNeutral800WithOpacity: SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DEFAULT_DARK,
  globalColorElevationLevel1: SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_100_FILL_DARK,
  semColorActionPrimaryForegroundIconDefault: SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_DARK,
  sysGradientElevationLevel3Fill: SYS_GRADIENT_ELEVATION_LEVEL3_FILL_DARK,
  sysColorForegroundNeutral300: SYS_COLOR_FOREGROUND_NEUTRAL_300_DARK,
};
const breakpoints = {
  xs: parseInt(SYS_BREAKPOINT_XS, 10),
  sm: parseInt(SYS_BREAKPOINT_SM, 10),
  md: parseInt(SYS_BREAKPOINT_MD, 10),
  lg: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};

const borderRadius = {
  max: SYS_BORDER_RADIUS_MAX,
};

const spacing = {
  sysSpaceFixed200: SYS_SPACE_FIXED_200,
  sysSpaceFixed300: SYS_SPACE_FIXED_300,
  sysSpaceFixed350: SYS_SPACE_FIXED_350,
  pageMargin: SYS_PAGE_MARGIN,
};
export const lightTheme: CustomTheme = {
  name: 'light',
  colors: colorsLight,
  breakpoints,
  borderRadius,
  spacing,
};

export const darkTheme: CustomTheme = {
  name: 'dark',
  colors: colorsDark,
  breakpoints,
  borderRadius,
  spacing,
};
